import { useFeatureFlagValue } from '@experiences/feature-flags';
import React from 'react';

import CheckGuard from '../../../container/helpers/CheckGuard';
import { CheckAccessProvider } from './CheckAccessContextProvider';
import type { CheckAccessLevel } from './CheckAccessScope';

const CheckAccessPageComponent = React.lazy(() => import('./CheckAccessPageComponent'));

interface ICheckAccessRouteElementProps {
    /** Scope the Check Access page is rendered for. */
    level: CheckAccessLevel;
}

/**
 * Shared route element for the tenant- and organization-level Check Access pages:
 * the (lazily loaded) page wrapped in a scope-aware `CheckAccessProvider`.
 */
export const CheckAccessRouteElement: React.FC<ICheckAccessRouteElementProps> = ({ level }) =>
    <CheckAccessProvider level={level}>
        <CheckAccessPageComponent />
    </CheckAccessProvider>;

interface ICheckAccessRouteGuardProps extends ICheckAccessRouteElementProps {
    /** Name of the feature flag that gates the page (e.g. `Features.EnableCheckAccess.name`). */
    featureFlag: string;
}

/**
 * `CheckAccessRouteElement` rendered behind a feature flag.
 */
export const CheckAccessRouteGuard: React.FC<ICheckAccessRouteGuardProps> = ({
    level, featureFlag,
}) => {
    const isEnabled = useFeatureFlagValue(featureFlag);

    return CheckGuard(isEnabled, <CheckAccessRouteElement level={level} />);
};
